import { IS_CLIENT, breakpointSizes, Breakpoints } from '../constants';
const getScreenSize = () => {
    if (IS_CLIENT) {
        const isXSmallBreakpoint = window.matchMedia(`(max-width: ${breakpointSizes.small - 1}px)`).matches;
        const isSmallBreakpoint = window.matchMedia(`(max-width: ${breakpointSizes.medium - 1}px)`).matches;
        const isMediumBreakpoint = window.matchMedia(`(max-width: ${breakpointSizes.large - 1}px)`).matches;
        const isLargeBreakpoint = window.matchMedia(`(max-width: ${breakpointSizes.xlarge - 1}px)`).matches;
        const isXLargeBreakpoint = window.matchMedia(`(max-width: ${breakpointSizes.xxl - 1}px)`).matches;
        if (isXSmallBreakpoint) {
            return Breakpoints.XSMALL;
        }
        if (isSmallBreakpoint) {
            return Breakpoints.SMALL;
        }
        if (isMediumBreakpoint) {
            return Breakpoints.MEDIUM;
        }
        if (isLargeBreakpoint) {
            return Breakpoints.LARGE;
        }
        if (isXLargeBreakpoint) {
            return Breakpoints.XLARGE;
        }
    }
    return Breakpoints.XXL;
};
export default getScreenSize;
//# sourceMappingURL=getScreenSize.js.map